import React from 'react';
import { BrandKitContainer } from '../store';
import { api } from '@unfold/api';
import { BrandKit } from './brand-kit';

export const BrandKitPage: React.FC = () => {
  return (
    <BrandKitContainer api={api}>
      <BrandKit />
    </BrandKitContainer>
  );
};
